/** @format */

import dayjs, { Dayjs } from 'dayjs'
import { getDataType } from './index'
// dayjs、string、date、时间戳 转 日期格式
export const formatDate = (
  date: Dayjs | string | Date | number,
  format = 'YYYY-MM-DD HH:mm:ss'
) => {
  if (date) {
    const type = getDataType(date)
    if (type === 'String' || type === 'Date' || type === 'Number') {
      return dayjs(date).format(format)
    } else {
      return (date as Dayjs).format(format)
    }
  } else {
    return ''
  }
}

// 时间戳转dayjs
export const timestampTodayjs = (timestamp: [number, number]): [Dayjs, Dayjs] => {
  return timestamp?.map(time => dayjs(time)) as [Dayjs, Dayjs]
}

export const getTimeDiffSimple = (start: number, end: number) => {
  const diffMs = Math.abs(dayjs(end).diff(dayjs(start)))
  const days = Math.floor(diffMs / (24 * 60 * 60 * 1000))
  const hours = Math.floor((diffMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
  const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000))
  const seconds = Math.floor((diffMs % (60 * 1000)) / 1000)
  return `${days}d ${hours}h ${minutes}m ${seconds}s`
}
